module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-37.99c4ceb9.png";